// TODO(Sergio): Temporary skip eslint rules, this is part of the A6-A12 migration from mono-frontend

/* eslint-disable complexity, @typescript-eslint/no-explicit-any, @angular-eslint/no-host-metadata-property, @typescript-eslint/ban-types */
import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  Directive,
  ElementRef,
  Inject,
  Input,
  PLATFORM_ID,
  Renderer2
} from '@angular/core';

@Directive({
  selector: '[idpHideElementOnTimeOut]'
})
export class IdpHideElementOnTimeOutDirective implements AfterViewInit {
  @Input() timeOutMSToHideElement = 0;
  dialogContentMaxHeight = 0;
  footerHeight = 0;

  constructor(
    public el: ElementRef,
    private renderer: Renderer2,
    // tslint:disable-next-line
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngAfterViewInit(): void {
    if (
      isPlatformBrowser(this.platformId) &&
      (window.innerWidth <= 414 || window.innerHeight <= 414) &&
      this.timeOutMSToHideElement
    ) {
      setTimeout(() => {
        this.renderer.addClass(this.el.nativeElement.children[0], 'slide-down');
        this.changeDialogContentHeight();
      }, this.timeOutMSToHideElement);
    }
  }

  changeDialogContentHeight() {
    this.footerHeight = Number(
      window
        .getComputedStyle(this.el.nativeElement.children[0])
        .height.replace('px', '')
    );

    const parentEle = this.renderer.parentNode(this.el.nativeElement);
    const dialogContent = parentEle.querySelector('.idp-dialog__content');
    this.dialogContentMaxHeight = Number(
      window.getComputedStyle(dialogContent).maxHeight.replace('px', '')
    );
    dialogContent.style.cssText =
      'max-height:calc(' +
      Math.ceil(this.dialogContentMaxHeight + this.footerHeight) +
      'px)';
  }
}
